module.exports = __webpack_public_path__ + "img/png-7.77390c83.png";